import React from 'react';
import styled from 'styled-components';
import Hero from './components/Hero';
import Navigation from './components/Navigation';
import Features from './components/Features';
import UseCases from './components/UseCases';
import ValueProposition from './components/ValueProposition';
import HowItWorks from './components/HowItWorks';
import Contact from './components/Contact';
import Footer from './components/Footer';
import GlobalStyles from './styles/GlobalStyles';

const AppContainer = styled.div`
  min-height: 100vh;
  background: #ffffff;
  color: #000000;
  overflow-x: hidden;
`;

function App() {
  return (
    <AppContainer>
      <GlobalStyles />
      <Navigation />
      <Hero />
      <Features />
      <ValueProposition />
      <UseCases />
      <HowItWorks />
      <Contact />
      <Footer />
    </AppContainer>
  );
}

export default App; 
